import { restApiClient } from '@/datasources';

interface RescheduleAppointmentProps {
  id: string;
  body: { slotId: string };
}

export const rescheduleAppointment = async ({ id, body }: RescheduleAppointmentProps) => {
  await restApiClient.post<void>(`/online/customers/appointments/${id}/reschedule/`, body);
};
